import { ExchangeCouponReq, SearchParams, SuggestResItem } from '@/apis/s/s.interface';
import { Props } from '@/app/s/util';
import { jdiColorFetch } from '../colorFetchV2';
import { logger } from '@/utils/logger';
import { SEARCH_EVENT_NAMES } from '@/utils/logger/instance/searchBusinessLogger';
import { getEdiTokenFromCookie } from '@/intl-jdi-common-ssr/utils/fingerprint';

export const getSearchResults = async (searchParams: Props['searchParams']): Promise<any> => {
  const p = Object.assign({}, searchParams);
  p.keywords = p.k;
  delete p.k;
  p.pageSize = '20';
  if (p.frontCategoryId) {
    delete p.keywords;
  }
  // 处理券搜的逻辑
  if (p.batchId) {
    p.couponBatchId = p.batchId;
    delete p.batchId;
    delete p.couponId;
  }
  // 处理店铺初次进入搜索页逻辑
  if (p.storeId) {
    p.shopId = p.storeId;
    delete p.keywords;
  }
  // 处理店铺内搜索字段
  if (p.shopId) {
    p.shopId = p.shopId;
    delete p.keywords;
    delete p.storeId;
  }
  if (p.shopKeywords) {
    p.shopKeywords = p.shopKeywords;
  }
  if (p.channelPageName) {
    p.channelPageName = p.channelPageName;
    p.poolIdList = p.poolIdList;
  }

  if (p.topKeyFilters?.includes('channel_page_filter')) {
    p.filterByPoolIds = p.poolIdList;
  }
  // 搜索请求开始
  logger.info({
    eventName: SEARCH_EVENT_NAMES.SEARCH_FETCH_START,
    message: {
      p,
    },
  });
  // @ts-ignore
  const res = await getShopItem(p);
  console.log('----bh------搜索请求参数', p);
  if (res.data?.paragraphs?.length === 0) {
    // 搜索结果无结果
    logger.info({
      eventName: SEARCH_EVENT_NAMES.SEARCH_FETCH_NO_DATA,
      statusCode: res.code,
      message: {
        p,
        res,
      },
    });
  }
  return res;
};

export const getSearchFieldCollection = async (
  searchParams: Props['searchParams'],
): Promise<any> => {
  const p: any = { keywords: searchParams.k, pageSize: 20, page: 1 };
  if (searchParams.frontCategoryId) {
    p.frontCategoryId = searchParams.frontCategoryId;
    delete p.keywords;
  }
  // 处理店铺初次进入搜索页逻辑
  if (searchParams.storeId) {
    p.shopId = searchParams.storeId;
    delete p.keywords;
  }
  // 处理店铺内搜索字段
  if (searchParams.shopId) {
    p.shopId = searchParams.shopId;
    p.shopKeywords = searchParams.shopKeywords;
    delete p.keywords;
  }
  //榜单获取筛选项
  if (searchParams.topKeyFilters) {
    p.topKeyFilters = searchParams.topKeyFilters;
  }
  if (searchParams.rankingSearch) {
    p.rankingSearch = searchParams.rankingSearch;
  }

  // filter请求开始
  logger.info({
    eventName: SEARCH_EVENT_NAMES.SEARCH_FILTER_FETCH_START,
    message: {
      p,
    },
  });
  const searchResults = await getShopItem(p);

  const { extAttrCollection } = searchResults?.data?.fieldCollection || {};
  if (extAttrCollection) {
    searchResults.data.fieldCollection.extAttrCollection = extAttrCollection.map((item: any) => ({
      ...item,
      collapse: false,
    }));
  }
  // filter请求无结果
  if (searchResults?.data?.fieldCollection?.brands?.length === 0) {
    logger.info({
      eventName: SEARCH_EVENT_NAMES.SEARCH_FILTER_NO_DATA,
      message: {
        p,
      },
    });
  }
  return {
    ...(searchResults?.data?.fieldCollection || {}),
    resultCountWhenOnlyKeywordExist: ~~searchResults?.data?.head?.summary?.resultCount,
  };
};

export const getSearchFieldCollectionForAddon = async (
  searchParams: Props['searchParams'],
): Promise<any> => {
  // @ts-ignore
  const searchResults = await getShopItem({
    keywords: searchParams.k,
    // @ts-ignore
    promotionId: searchParams.promotionId,
    // @ts-ignore
    couponBatchId: searchParams.batchId,
    pageSize: 20,
    page: 1,
    // @ts-ignore
    shipmentType: searchParams.shipmentType,
  });
  return {
    ...(searchResults?.data?.fieldCollection || {}),
    resultCountWhenOnlyKeywordExist: ~~searchResults?.data?.head?.summary?.resultCount,
  };
};

// 这个是直接调用搜索接口的方法，不宜直接调用，因为搜索的参数较多，需要处理一些排除的逻辑，建议使用 getSearchResults
const getShopItem = async (params: SearchParams): Promise<any> => {
  const res = await jdiColorFetch(
    `guide_search_getItems`,
    {
      method: 'post',
      bodyQuery: params,
      next: { revalidate: 5 },
      params: {
        uuid: await getEdiTokenFromCookie(),
      },
    },
    { needUniformBizInfo: true },
  );
  return res;
};

// 热词
export const getHotWords = async (params: { num: number; shopId: string }): Promise<any> => {
  const res = await jdiColorFetch(
    `guide_search_getHotWords`,
    {
      method: 'post',
      bodyQuery: params,
    },
    { needUniformBizInfo: true },
  );
  return res;
};
// 联想词
export const getSuggestWords = async (params: SuggestResItem): Promise<any> => {
  const res = await jdiColorFetch(
    `guide_search_getSuggestWords`,
    {
      method: 'post',
      bodyQuery: params,
    },
    { needUniformBizInfo: true },
  );
  return res;
};

export const marketingCouponExchange = async (params: ExchangeCouponReq[] = []): Promise<any> => {
  const res = await jdiColorFetch(`marketing_coupon_exchange`, {
    method: 'post',
    bodyQuery: { coupons: params },
  });
  return res;
};

export const getDefaultWords = async (): Promise<any> => {
  // return { data: [] };
  const res = await jdiColorFetch(`guide_search_getDefaultWord`, {
    method: 'get',
  });
  return res;
};

//渠道价弹窗
export const getChannelPricePop = async (params: { activityId: number }): Promise<any> => {
  const res = await jdiColorFetch(
    `marketing_activity_getChannelPricePopUp`,
    {
      method: 'post',
      bodyQuery: params,
    },
    { needUniformBizInfo: true },
  );
  return res;
};
